// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__1UZs1","active":"Modal_active__81LRW","inner":"Modal_inner__TMwXe","closeBtn":"Modal_closeBtn__HTQhU"};